<template>
  <div>
    <v-container class="pt-8 px-10">
      <h1 class="display-1 mb-4">{{ title }}</h1>
      <v-row class="px-4">
        <v-btn class="primary mb-4" @click="makeNewMember">
          <v-icon class="mr-1">mdi-plus</v-icon>New
        </v-btn>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" class="primary mb-4 ml-4">
              <v-icon class="mr-1">mdi-sort</v-icon>Sort by
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(title, key) in sortOptions"
              :key="key" 
              :class="{ grey: sort === key, 'lighten-2': true }"
              @click="sort = key"
            >
              <v-list-item-title>
                {{ title }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-row>
      <v-layout row wrap>
        <v-flex 
          v-for="member in sortedMembers" 
          :key="member.id" 
          xs12 sm6 md4 lg3
        >
          <FbMemberListItem 
            :id="member.id"
            :type="type"
            :member="member"
            @delete="confirmDeleteMember" />
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="deleteDialog.show" max-width="290">
      <v-card>
        <v-card-title class="headline">Delete Item</v-card-title>
        <v-card-text>
          Are you sure you want to delete <strong>{{ deleteDialog.name }}</strong>?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteDialog.show = false">Cancel</v-btn>
          <v-btn color="error" text @click="deleteMember">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { randomId, prefGet, prefSet } from '../utils'
import { FbMember } from '../constants'

import FbMemberListItem from '../components/FbMemberListItem'

const memberDefs = {
  [FbMember.Profile]: {
    title: 'Profiles',
    path: 'profiles',
    defaultSort: 'firstName',
    sortOptions: {
      firstName: 'First Name',
      lastName: 'Last Name',
      birthdate: 'Birthdate',
      friendCount: 'Friends'
    }
  },
  [FbMember.Page]: {
    title: 'Pages',
    path: 'pages',
    defaultSort: 'name',
    sortOptions: {
      name: 'Name',
      category: 'Category',
      likeCount: 'Likes'
    }
  },
  [FbMember.Group]: {
    title: 'Groups',
    path: 'groups',
    defaultSort: 'name',
    sortOptions: {
      name: 'Name',
      memberCount: 'Members'
    }
  }
}

export default {
  name: 'FbMemberList',
  injectModels: ['Store'],
  components: {
    FbMemberListItem
  },
  props: {
    type: String
  },
  data() {
    return {
      members: {},
      sort: '',
      deleteDialog: {
        show: false,
        id: '',
        name: ''
      }
    }
  },
  created() {
    this.onTypeChanged()
  },
  computed: {
    title() {
      return memberDefs[this.type].title
    },
    sortOptions() {
      return memberDefs[this.type].sortOptions
    },
    sortedMembers() {
      const members = Object.keys(this.members)
        .filter(id => !id.startsWith('RAND_'))
        .map(id => ({ id, ...this.members[id] }))

      if (!this.sort)
        return members
        
      return members.sort((a, b) => {
        a = a[this.sort]
        b = b[this.sort]
        // Case-insensitive lexi sorting
        if (typeof a === 'string' && typeof b === 'string')
          [a, b] = [a, b].map(s => s.toLowerCase())

        return a > b
      })
    }
  },
  methods: {
    onTypeChanged() {
      const { path, defaultSort } = memberDefs[this.type]
      if (!(path in this.Store.fb))
        this.Store.fb[path] = {}

      this.members = this.Store.fb[path]
      this.sort = prefGet(this.prefKey('sort'), defaultSort)
    },
    prefKey(prop) {
      return `FbMemberList_${prop}_${this.type}`
    },
    makeNewMember() {
      const id = randomId()
      this.$set(this.members, id, {})
      this.$router.push({ path: id, append: true })
    },
    confirmDeleteMember(id, name) {
      this.deleteDialog = { show: true, id, name }
    },
    deleteMember() {
      this.$delete(this.members, this.deleteDialog.id)
      this.deleteDialog.show = false
    }
  },
  watch: {
    type() {
      this.onTypeChanged()
    },
    sort(value) {
      prefSet(this.prefKey('sort'), value)
    }
  }
} 
</script>
